import { App, NavController, NavParams,LoadingController, ToastController } from 'ionic-angular';
import { UserPostPage } from '../user-posts/user-posts';
import { ApiService } from '../../api-service/api-service';

import { Component, ViewChild } from '@angular/core';
import { Content } from 'ionic-angular';

import { User,UserPost,UserComment,UserData } from '../../providers/providers';

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;

const url = 'https://cdn.chitika.net/getads.js';

@Component({
  templateUrl: 'leaderboard.html'
})
export class LeaderBoardPage {

  leaderBoardUsers:UserData[] = [];

  loadAPI: Promise<any>;
  private s3: any;
  public level: number = 1;
  public sort:string = "wins";
  public lastKey: any = "";
  public IScroll:any;
  public loading:any;
  public userPostPage = UserPostPage;
  public placement_id:number;
  public bannerId:string = "not set";
  

  constructor(public navCtrl: NavController,public navParams:NavParams,public server:ApiService,
    public user:User,
    public toastCtrl: ToastController, public userData:UserData,public loadingCtrl: LoadingController) {
      

    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
        this.s3 = new AWS.S3({
            'params': {
            'Bucket': aws_user_files_s3_bucket
            },
            'region': aws_user_files_s3_bucket_region
        });
      this.getLeaderBoardUsers();
      //this.chitikaAddHeight();
  }

  ngOnInit(){
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        this.loadScript();
    });
}

public loadScript() {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.chitikaAddHeight();
}


  getLeaderBoardUsers(){
    this.server.showLeaderBoard(this.level,this.sort,this.lastKey,this.getLeaderBoardUsersCallback);
  }

  //Fat arrow used to keep scope, private entry back in
  public getLeaderBoardUsersCallback = (leaderBoardData) => {
    this.loadLeaderBoardfromCallback(leaderBoardData);
  }


  loadLeaderBoardfromCallback(leaderBoardUsers){
    if(leaderBoardUsers.LastEvaluatedKey){
        this.lastKey = leaderBoardUsers.LastEvaluatedKey;
      }
      else
      {
        this.lastKey = "";
      }
    
    for (let i = 0; i < leaderBoardUsers.Items.length; i++) {
        this.s3.getSignedUrl('getObject', {'Key': leaderBoardUsers.Items[i].avatarKey}, (err, avatarUrl) => {
            leaderBoardUsers.Items[i].avatarURL = avatarUrl;
          this.leaderBoardUsers.push( leaderBoardUsers.Items[i] );
        });
      };
       
       if(this.IScroll){
         this.IScroll.complete();
       }
       this.loading.dismiss();
       //this.commentMessage = "";
    }
  

    setSort(sortOrder){
      if(this.sort !== sortOrder){
        //this.loading.present();
        this.sort = sortOrder;
        this.leaderBoardUsers = [];
        this.getLeaderBoardUsers();
      }
      
    }

    getUserLadder(userLadderName:string,avatarLadderURL:string){
      //alert(userLadderName+" : "+avatarLadderURL);
      this.navCtrl.push(this.userPostPage, {userName:userLadderName, userAvatar:avatarLadderURL});
    }
    
  doInfinite(infiniteScroll) {
    this.IScroll = infiniteScroll;
    console.log('Begin async operation');
    if (this.lastKey !== "")
    {
        this.server.showLeaderBoard(this.level,this.sort,this.lastKey,this.getLeaderBoardUsersCallback);
    }
    else
    {
      infiniteScroll.complete();
    }
    /*setTimeout(() => {
      for (let i = 0; i < 30; i++) {
          let fakePost = new UserPost("Funny");
          fakePost.generateTestPost();
        this.items.push( fakePost );
      }

      console.log('Async operation has ended');
      infiniteScroll.complete();
    }, 500);
    */
  }

  chitikaAddHeight(){
    if (window['CHITIKA'] === undefined) { window['CHITIKA'] = { 'units' : [] }; };
          var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
          this.placement_id = window['CHITIKA'].units.length;
          window['CHITIKA'].units.push(unit);
          this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
          //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
  }

}



// WEBPACK FOOTER //
// ./src/pages/leaderboard/leaderboard.ts